// @ts-check
import RoleListbox from "./listbox.js";

RoleListbox.define();

export default RoleListbox;
export * from './listbox.js';

/**
 * @type {import("./listbox-globals.js")}
 */
